<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :batch-edit="auth('b_task_edit')" :view-config="auth('b_task_viewmanage')" :custom-view="customView" @customView="data => $refs.gantt.load(data)">
				<template #search>
					<m-search ref="search">
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="工序编号">
							<c-input name="process_code"></c-input>
						</m-search-item>
						<!-- <m-search-item label="工序名称">
							<c-input name="process_name"></c-input>
						</m-search-item> -->
						<m-search-item label="工序">
							<c-select name="process_ids" multiple async @search="searchProcess"></c-select>
						</m-search-item>
						<m-search-item label="工单状态">
							<c-select name="work_states" :options="orderStateNoCancelDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="任务状态">
							<c-select name="states" :options="orderStateNoCancelDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item>
							<c-checkbox-group name="pre_state_ok">
								<c-checkbox value="1">前任务工序已结束</c-checkbox>
							</c-checkbox-group>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_task_create')" v-lock="lock('b_task_create')" prepend-icon="tf-add" @click="editTask()">创建任务</c-button>
					<c-button v-if="auth('b_task_export') && !customView" v-lock="lock('b_task_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_task_export') && !customView" v-lock="lock('b_task_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_task_export')" v-lock="lock('b_task_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_task_export')" v-lock="lock('b_task_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_task_print')" v-lock="lock('b_task_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>

                    <c-dropdown>
                        <c-button prepend-icon="tf-batch">批量操作</c-button>

                        <template #menu>
                            <c-menu-list>
								<!-- 修改状态 -->
								<c-menu-list v-if="auth('b_task_edit_state')">
									<c-menu-item icon="tf-edit-border">状态</c-menu-item>
									<template #menu>
										<c-menu-item icon="tf-recall" @click="editState(null, 1)">未开始</c-menu-item>
										<c-menu-item icon="tf-start" @click="editState(null, 2)">执行中</c-menu-item>
										<c-menu-item icon="tf-end" @click="editState(null, 3)">已结束</c-menu-item>
									</template>
								</c-menu-list>
                                <c-menu-item v-if="auth('b_task_priority')" v-lock="lock('b_task_priority')" icon="tf-priority" @click="editPriority">优先级</c-menu-item>
                                <c-menu-item v-if="auth('b_task_distribute')" v-lock="lock('b_task_distribute')" icon="tf-assign" @click="batchAllotTask">分配</c-menu-item>
                                <c-menu-item v-if="auth('b_task_delete')" v-lock="lock('b_task_delete')" icon="tf-trash" color="red" :hollow="true" @click="batchRemoveTask">删除</c-menu-item>
                            </c-menu-list>
                        </template>
                    </c-dropdown>
				</template>

				<template #otherOperate>
					<c-button prepend-icon="tf-view" @click="customView = !customView">{{customView ? '返回列表' : '查看甘特图'}}</c-button>
					<c-button v-if="auth('b_task_log')" v-lock="lock('b_task_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<!--产品来源-->
				<template #product_source="{data}">
					<c-state dict="productSourceName" :value="data.product_source"></c-state>
				</template>

				<!--产品类型-->
				<template #product_type="{data}">
					<c-state dict="productTypeName" :value="data.product_type"></c-state>
				</template>
				
				<!--加工类型-->
				<template #process_type="{data}">
					<c-state dict="processTypeDic" :value="data.process_type"></c-state>
				</template>
				
				<!--检验方式-->
				<template #test_mode="{data}">
					<c-state dict="testModeDic" :value="data.test_mode"></c-state>
				</template>
				
				<!--生产顺序（1：在前工序之后，2：与前工序同时）-->
				<template #production_sequence="{data}">
					<c-state dict="productionSequenceDic" :value="data.production_sequence"></c-state>
				</template>
				
				<!--自动出库-->
				<template #material_auto_out="{data}">
					<c-state dict="openCloseDic" :value="data.material_auto_out"></c-state>
				</template>
				
				<!--自动入库-->
				<template #product_auto_in="{data}">
					<c-state dict="openCloseDic" :value="data.product_auto_in"></c-state>
				</template>
				
				<!--报工前打卡（0：不开启，1：开启）-->
				<template #output_start="{data}">
					<c-state dict="openCloseDic" :value="data.output_start"></c-state>
				</template>

				<!--任务状态-->
				<template #state="{data}">
					<c-state dict="orderStateDic" tag :value="data.state"></c-state>
				</template>
				
				<!--逾期状态-->
				<template #plan_date_state="{data}">
					<c-state type="expectedDate" :value="data.expected_date"></c-state>
				</template>
				
				<!--优先级-->
				<template #priority="{data}">
					<c-state dict="priorityDic" tag :value="data.priority"></c-state>
				</template>
				
				<!--报工权限 -->
				<template #output_auth_names="{data}">
					<span v-if="!data.output_auth_names" >-</span>
					<c-tags v-else :value="data.output_auth_names"></c-tags>
				</template>
				
				<!--最终报工权限(综合报工权限、分配报工权限，并考虑分配是否优先) -->
				<template #all_output_auth_names="{data}">
					<span v-if="!data.all_output_auth_names" >-</span>
					<c-tags v-else :value="data.all_output_auth_names"></c-tags>
				</template>
				
				<!--任务分配 -->
				<template #output_distribute_auth_names="{data}">
					<div class="flex-center">
						<div class="flex-grow">
							<c-tags v-if="data.output_distribute_auth_names" :value="data.output_distribute_auth_names"></c-tags>
						</div>
						<c-link v-if="auth('b_task_distribute') && (data.work_state == 1 || data.work_state == 2)" color="main" style="margin-left: 10px; font-size: 20px;" @click="globalDialog('taskAllot', {data}, $refs.view.refresh)"><i class="tf">&#xe691;</i></c-link>
					</div>
				</template>
				
				<!--工单状态-->
				<template #work_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
				</template>
				
				<!--任务进度%-->
				<template #task_progress="{data}">
					<c-progress :rate="[data.fine_count, data.plan_count]" :color="((data.fine_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
				</template>
				
				<!--关联单据-->
				<template #ref_code="{data}">
					<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
				</template>
				
				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>
				
				<!--委外单-->
				<template #out_sourcing_order_code="{data}">
					<order-link type="outSourcing" :data="data.out_sourcing_orders"></order-link>
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="180"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_task_edit')" v-lock="lock('b_task_edit')" icon="tf-edit" @click="editTask(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_task_output')" v-lock="lock('b_task_output')" :disabled="!(data.output_is_auth == 1 && data.work_state == 2 && data.process_type == 1)" icon="tf-output" @click="outputTask(data)">报工</c-table-button>
						<c-table-button v-if="auth('b_task_sourcing') && (data.state==1 || data.state==2) && data.work_state == 2 && data.process_type == 2" v-lock="lock('b_task_sourcing')" icon="tf-outsource" @click="editSourcing(data)">{{data.out_sourcing_plan_count>0?'再次外发':'外发'}}</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('taskDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_task_print')" v-lock="lock('b_task_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_task_priority')" v-lock="lock('b_task_priority')" icon="tf-priority" @click="editPriority(data)">优先级</c-table-button>
						<c-table-button v-if="auth('b_task_delete')" v-lock="lock('b_task_delete')" icon="tf-trash" color="red" @click="removeTask(data)">删除</c-table-button>
					</template>
				</c-table-column>

				<template #customView>
					<gantt ref="gantt" scene="task"></gantt>
				</template>
			</view-list>
			
			<!--编辑任务信息弹窗-->
			<task-edit ref="taskEdit" @resolve="updateMethod"></task-edit>
			<!--编辑任务优先级弹窗-->
			<priority-edit ref="priorityEdit" @resolve="$refs.view.refresh()"></priority-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import gantt from './gantt.vue'
	import taskEdit from "@/pages/production/task_edit.vue";
	import priorityEdit from "@/pages/production/task_edit_priority.vue";

	export default {
		components: {
			gantt,
			taskEdit,
			priorityEdit
		},
		
		data() {
			return {
                workType:13,
				customView: false,
				editFlag: false
			}
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateNoCancelDic', 'productionSequenceDic'])
		},
		
		mounted() {
		    this.$bus.$on('task.list.update', data => {
		        // 刷新列表
		        this.$refs.view.refresh();
		    });
		},
		
		beforeDestroy() {
			this.$bus.$off('task.list.update');
		},
		
		methods: {

			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			updateMethod(){
				//修改
				if(this.editFlag){
					this.$refs.view.refresh();
				}else{
					this.$refs.view.update();
				}
			},
			
			/******编辑任务*******/
			editTask(data) {
				if(data){
					this.editFlag = true;
				}else{
					this.editFlag = false;
				}
				this.$refs.taskEdit.open(data);
			},
			
			/**编辑任务优先级*/
			editPriority(data) {
				if(!data){
					var ids = [];
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
					this.$refs.priorityEdit.batchOpen(ids);
				}else{
					this.$refs.priorityEdit.open(data);
				}
				
			},

			/**编辑任务外发（即创建委外单）*/
			editSourcing(data) {
				this.globalDialog('outSourcingEdit', {
					props: {
						byTask: true
					},
					data
				}, this.$refs.view.refresh);
			},
			
			/**任务报工*/
			outputTask(data) {
				this.globalDialog('outputEdit', {
					props: {
						byTask: true
					},
					data
				}, this.$refs.view.refresh);
			},
			
			/****批量分配任务***/
			batchAllotTask(){
				let selected = this.$refs.view.$refs.list.getData('selected');
				if(!selected.length){
					this.$message({
						message: '请先勾选任务'
					});
					return;
				}
				this.globalDialog('taskAllotBatch', {data: selected}, this.$refs.view.refresh);
			},
			
			/****批量删除任务***/
			batchRemoveTask(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条任务记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/task/delete/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******删除任务************/
			removeTask(data){
				this.$confirm({
					message:'确认删除此任务吗？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/task/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******修改任务状态************/
			editState(data, task_state){
				if(!data){
					var ids = [];
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
					this.batchEditStateHandler(ids, task_state);
					
				}else{
					this.editStateHandler(data.id, task_state)
				}
			},
			
			/******修改任务状态(提交数据)************/
			editStateHandler(task_id, task_state){
				this.request({
					url: '/task/editState',
					data: {
						id: task_id , 
						state: task_state,
					},
					loading: true,
					success: data => {
						var mess = '操作成功';
						
						this.$message({
							message: mess,  // 提示内容,
							type: 'success'
						});
						//刷新
						this.$refs.view.refresh();
					}
				});
			},
			
			/******批量修改任务状态(提交数据)************/
			batchEditStateHandler(ids, task_state){
				this.request({
					url: '/task/editState/batch',
					data: {
						ids: ids , 
						state: task_state,
					},
					loading: true,
					success: data => {
						var mess = '操作成功';
						
						let Mtype = 'success';
						let message = mess + data.success_count + '条';
						if(data.fail_count > 0 && data.success_count > 0){
							Mtype = 'warn';
							message += '，失败'+data.fail_count+'条';
						}else if(data.fail_count > 0 && data.success_count == 0){
							Mtype = 'fail'
							message += '，失败'+data.fail_count+'条';
						}else{
							message = mess + data.success_count + '条记录';
						}
						this.$message({
							message: message,  // 提示内容,
							type: Mtype
						});
						//刷新
						this.$refs.view.refresh();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>